<div
  class="flex flex-column align-items-center justify-content-center w-full h-full gap-6"
>
  <p-card [style]="{ maxWidth: '25rem', width: '100%', overflow: 'hidden' }">
    <ng-template #header>
      <div class="flex justify-content-center py-6 px-4 bg-white">
        <app-responsive-logo path="assets/images/logo-md.svg" />
      </div>
    </ng-template>
    <ng-template #footer>
      <div
        class="flex flex-column align-items-center justify-content-center mt-1 gap-4"
      >
        <p-tag
          severity="info"
          [value]="'LOGIN.REDIRECTION_WAITING_MESSAGE' | translate"
          icon="pi pi-spin pi-cog"
          styleClass="waiting_message_tag"
        />
        <span class="text-sm font-bold">{{
          'LOGIN.REDIRECTION_MESSAGE' | translate
        }}</span>
      </div>
    </ng-template>
  </p-card>
</div>
